import { useAppSelector } from '@redux/store';

import { checkContractCompletion } from '@/redux/selectors/contractSelectors';

import { type ContractData } from '../types/contract';

const useCompletionContractCheck = (data?: ContractData): boolean =>
  useAppSelector((state) => checkContractCompletion(state, data));

export { useCompletionContractCheck };
